// @flow
import React from 'react';
import classNames from 'classnames';
import { t } from 'javascripts/utils/withTranslation';
import Icon from 'components/_particles/icon/react/Icon';

const RteToolbar = ({
  editor,
  isDisabled,
}: {
  editor: any,
  isDisabled?: boolean,
}): React$MixedElement | null => {
  if (!editor) {
    return null;
  }

  const handleButtonClick = (event: SyntheticEvent<HTMLButtonElement>) => {
    ((event.target: any): HTMLElement)
      ?.closest('.input__rte-editor-wrapper')
      ?.classList.add('active-focus-overlay');
  };

  const handleBoldClick = (event: SyntheticEvent<HTMLButtonElement>) => {
    editor.chain().focus().toggleBold().run();
  };

  const handleBulletListClick = (event: SyntheticEvent<HTMLButtonElement>) => {
    editor.chain().focus().toggleBulletList().run();
  };

  const handleOrderedListClick = (event: SyntheticEvent<HTMLButtonElement>) => {
    editor.chain().focus().toggleOrderedList().run();
  };

  return (
    <div
      className="input__rte-toolbar"
      role="toolbar"
      aria-label={t('Textformatierung')}
    >
      <button
        type="button"
        onClick={handleBoldClick}
        className={classNames(
          'input__rte-button',
          editor.isActive('bold') ? 'input__rte-button--active' : '',
        )}
        title={t('Schrift fetten')}
        disabled={isDisabled}
      >
        <strong aria-hidden="true">{t('F')}</strong>
        <span className="u-hidden-visually">{t('Fett')}</span>
      </button>
      <span className="input__rte-separator" aria-hidden="true"></span>
      <button
        type="button"
        onClick={handleBulletListClick}
        className={classNames(
          'input__rte-button',
          editor.isActive('bulletList') ? 'input__rte-button--active' : '',
        )}
        title={t('Aufzählung')}
        disabled={isDisabled}
      >
        <Icon icon="bw-bullet-list-solid" title={t('Aufzählung')} />
      </button>
      <button
        type="button"
        onClick={handleOrderedListClick}
        className={classNames(
          'input__rte-button',
          editor.isActive('orderedList') ? 'input__rte-button--active' : '',
        )}
        title={t('Nummerierung')}
        disabled={isDisabled}
      >
        <Icon icon="bw-numbered-list-line" title={t('Nummerierung')} />
      </button>
    </div>
  );
};

export default RteToolbar;
